import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { LoginComponent } from './pages/login/login.component';
import { AdminUserManagementComponent } from './pages/admin/admin-user-management/admin-user-management.component';
import { AdminLayoutComponent } from './pages/admin/admin-layout/admin-layout.component';
import { ManageProjectsComponent } from './pages/admin/admin-manage-projects/admin-manage-projects.component';
import { ManageCustomersComponent } from './pages/admin/admin-manage-customers/admin-manage-customers.component';
import { ManageLanguagesComponent } from './pages/admin/admin-manage-languages/admin-manage-languages.component';
import { AdminServiceCreditsComponent } from './pages/admin/admin-service-credits/admin-service-credits.component';
import { DesignerLayoutComponent } from './pages/designer/designer-layout/designer-layout.component';
import { TemplateListComponent } from './pages/designer/template-list/template-list.component';
import { TemplateFormComponent } from './pages/designer/template-form/template-form.component';
import { PropertyEditorComponent } from './pages/designer/property-editor/property-editor.component';
import { LayoutListComponent } from './pages/designer/layout-list/layout-list.component';
import { LayoutFormComponent } from './pages/designer/layout-form/layout-form.component';
import { LayoutLinesComponent } from './pages/designer/layout-lines/layout-lines.component';
import { ObjectGroupListComponent } from './pages/designer/object-group-list/object-group-list.component';
import { ObjectGroupFormComponent } from './pages/designer/object-group-form/object-group-form.component';
import { ObjectGroupLinesComponent } from './pages/designer/object-group-lines/object-group-lines.component';
import { SlideTypeLinesComponent } from './pages/designer/slide-type-lines/slide-type-lines.component';
import { SlideTypeFormComponent } from './pages/designer/slide-type-form/slide-type-form.component';
import { SlideTypeListComponent } from './pages/designer/slide-type-list/slide-type-list.component';
import { ProjectParametersComponent } from './pages/admin/project-parameters/project-parameters.component';
import { ProjectListComponent } from './pages/creator/project-list/project-list.component';
import { CreatorLayoutComponent } from './pages/creator/creator-layout/creator-layout.component';
import { ProjectSlidesComponent } from './pages/creator/project-slides/project-slides.component';
import { SlidelinesComponent } from './pages/creator/slidelines/slidelines.component';
import { ProjectFromLessonComponent } from './pages/creator/project-from-lesson/project-from-lesson.component';
import { AudioGenComponent } from './pages/creator/audio-gen/audio-gen.component';
import { LessonExcelImportComponent } from './pages/creator/lesson-excel-import/lesson-excel-import.component';
import { SMEDashboardComponent } from './pages/SME/smedashboard/smedashboard.component';
import { LessonMetaComponent } from './pages/SME/lesson-meta/lesson-meta.component';
import { TOCEditorComponent } from './pages/SME/toceditor/toceditor.component';
import { SMELayoutComponent } from './pages/SME/sme-layout/sme-layout.component';
import { LessonSlideEditorComponent } from './pages/SME/lesson-slide-editor/lesson-slide-editor.component';
import { SMEChatComponent } from './pages/SME/sme-chat/sme-chat.component';
import { SMEChatLessonCreateComponent } from './pages/SME/sme-chat/sme-chat-lesson-create.component';
import { SMEHelpGuideComponent } from './pages/SME/sme-help-guide/sme-help-guide.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AdminUserManagementComponent,
    AdminLayoutComponent,
    ManageProjectsComponent,
    DesignerLayoutComponent,
    TemplateListComponent,
    TemplateFormComponent,
    PropertyEditorComponent,
    LayoutListComponent,
    LayoutFormComponent,
    LayoutLinesComponent,
    ObjectGroupListComponent,
    ObjectGroupFormComponent,
    ObjectGroupLinesComponent,
    SlideTypeLinesComponent,
    SlideTypeFormComponent,
    SlideTypeListComponent,
    ProjectParametersComponent,
    ProjectListComponent,
    CreatorLayoutComponent,
    ProjectSlidesComponent,
    SlidelinesComponent,
    ProjectFromLessonComponent,
    AudioGenComponent,
    LessonExcelImportComponent,
    SMEDashboardComponent,
    LessonMetaComponent,
    TOCEditorComponent,
    SMELayoutComponent,
    LessonSlideEditorComponent,
    SMEChatComponent,
    SMEChatLessonCreateComponent,
    SMEHelpGuideComponent,
      ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule, // required
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      timeOut: 3000
    }),
    CommonModule,
    AppRoutingModule,
    FormsModule,
    ManageCustomersComponent,
    ManageLanguagesComponent,
    AdminServiceCreditsComponent,
    HttpClientModule,
    ReactiveFormsModule,
    RouterModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

